interface SectionProps {
  children: React.ReactNode;
  variant?: "default" | "dark" | "subtle";
  className?: string;
  id?: string;
}

export function Section({ children, variant = "default", className, id }: SectionProps) {
  const base = "section";
  const variantCls =
    variant === "dark" ? "section-dark" : variant === "subtle" ? "section-subtle" : "";
  return (
    <section id={id} className={[base, variantCls, className].filter(Boolean).join(" ")}>
      <div className="container">{children}</div>
    </section>
  );
}

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  dark?: boolean;
  center?: boolean;
}

export function SectionHeader({
  eyebrow,
  title,
  description,
  dark,
  center = true,
}: SectionHeaderProps) {
  return (
    <div
      style={{
        maxWidth: center ? "640px" : "none",
        margin: center ? "0 auto var(--space-8)" : "0 0 var(--space-6)",
        textAlign: center ? "center" : "left",
      }}
    >
      {eyebrow && (
        <div className={`eyebrow ${dark ? "eyebrow-dark" : ""}`} style={{ marginBottom: "0.75rem" }}>
          {eyebrow}
        </div>
      )}
      <h2 style={{ color: dark ? "var(--text-on-dark)" : "var(--text)" }}>{title}</h2>
      {description && (
        <p className={`lead ${dark ? "lead-dark" : ""}`} style={{ marginTop: "1rem" }}>
          {description}
        </p>
      )}
    </div>
  );
}
